import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { CompanyParametersQuery, CompanyParametersQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(CompanyParametersQuery)
@Wrapper(CompanyParametersQueryHandlerBase)
export class CompanyParametersQueryHandler {
    public constructor(
        http: Http
    ) { }
}
